import { useEffect } from "react";
export function getAdjacentCallId(callIds, currentCallId, direction) {
    const currentIndex = callIds.indexOf(currentCallId);
    if (currentIndex === -1)
        return null;
    const adjacentIndex = currentIndex + (direction === "previous" ? -1 : 1);
    return callIds[adjacentIndex] ?? null;
}
function isEditableTarget(target) {
    if (!(target instanceof Element))
        return false;
    return Boolean(target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]'));
}
export function useCallNavigationShortcuts({ enabled, onPrevious, onNext, }) {
    useEffect(() => {
        if (!enabled)
            return;
        const handleKeyDown = (event) => {
            if (event.defaultPrevented ||
                event.altKey ||
                event.ctrlKey ||
                event.metaKey ||
                event.shiftKey ||
                isEditableTarget(event.target)) {
                return;
            }
            if (event.key.toLowerCase() === "k" && onPrevious) {
                event.preventDefault();
                onPrevious();
            }
            else if (event.key.toLowerCase() === "j" && onNext) {
                event.preventDefault();
                onNext();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [enabled, onNext, onPrevious]);
}
